export type Buyer = {
  name: string
  city: string
  country: string
}

export const BUYERS: Buyer[] = [
  { name: 'Jennifer M.', city: 'Austin, TX', country: 'United States' },
  { name: 'Sarah L.', city: 'Toronto, ON', country: 'Canada' },
  { name: 'Emily R.', city: 'Brisbane, QLD', country: 'Australia' },
  { name: 'Michelle P.', city: 'Denver, CO', country: 'United States' },
  { name: 'Rachel K.', city: 'Vancouver, BC', country: 'Canada' },
  { name: 'Olivia T.', city: 'Melbourne, VIC', country: 'Australia' },
  { name: 'Amanda C.', city: 'Chicago, IL', country: 'United States' },
  { name: 'Laura B.', city: 'Calgary, AB', country: 'Canada' },
  { name: 'Sophie W.', city: 'Sydney, NSW', country: 'Australia' },
  { name: 'Karen D.', city: 'Phoenix, AZ', country: 'United States' },
  { name: 'Nicole H.', city: 'Ottawa, ON', country: 'Canada' },
  { name: 'Hannah G.', city: 'Perth, WA', country: 'Australia' },
  { name: 'Diana S.', city: 'San Diego, CA', country: 'United States' },
  { name: 'Claire F.', city: 'Montreal, QC', country: 'Canada' },
  { name: 'Grace N.', city: 'Adelaide, SA', country: 'Australia' },
]
